const Data = [
  
    {
        name: "Himanshu Verma",
        position: "SRC Head",
        imageUrl: "/assets/images/members/Heads23/Himanshu Verma.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100074582708104",
        linkedinLink: "https://www.linkedin.com/in/himanshu-verma-26a8b5223",
        email: "himanshu.verma@gyws.org"
    },

    {
        name: "Kopal Jain",
        position: "SRC Head",
        imageUrl: "/assets/images/members/Heads23/Kopal Jain.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Shruti Srivatsava",
        position: "SRC Head",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Vishal Kumar Lal",
        position: "SRC Head",
        imageUrl: "/assets/images/members/Heads23/VishalKumar.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
]

export default Data;